<div class="custom-mat-dialog-form add-project-modal">
  <div class="header-container">
    <h4>Select the project</h4>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-12 form-group">
          <ng-select [items]="projectList"
                      [searchable]="true"
                      [clearable]="false"
                      bindLabel="projectName"
                      bindValue="id"
                      formControlName="projectId">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <b>{{item.projectName}}</b>
                      </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="panel-body">
        <button type="button" (click)="backButtonHandler($event)" mat-raised-button class="btn button-color-fix_red">
          <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
          Back
        </button>
        <button mat-raised-button type="submit" class="btn button-color-fix pull-right" [disabled]="!form.valid">
          Continue
          <mat-icon class="icon-color-fix">arrow_forward_ios</mat-icon>
        </button>
      </div>
    </form>
  </div>
</div>